<template>
    <div class="wrong-book-card">
        <div class="card-container">
            <!-- 卡片头部 -->
            <div class="card-header">
                <div class="header-left">
                    <span class="question-type-tag">
                        <i class="el-icon-edit-outline"></i>
                        {{ worngBookDetails.questionType | formatQuestionType }}
                    </span>
                    <span class="divider">|</span>
                    <span class="answer-time">
                        <i class="el-icon-time"></i>
                        {{ worngBookDetails.createTime }}
                    </span>
                </div>
            </div>

            <!-- 卡片内容 -->
            <div class="card-content">
                <radioSubject v-if="(questionBody.questionType === 0) || (questionBody.questionType === 1)"
                              :subjectId="subjectId"
                              :questionBody="questionBody" :haveAnswer="true" :isDis="true"
                              :chooseItem="questionBody.answerInfo.content"
                              @openAmendDialog="openAmendDialog"
                              @openAnalysisDialog="openAnalysisDialog">
                </radioSubject>
                <checkSubject v-if="questionBody.questionType === 2" :subjectId="subjectId" :questionBody="questionBody"
                              :haveAnswer="true" :isDis="true"
                              @openAmendDialog="openAmendDialog"
                              @openAnalysisDialog="openAnalysisDialog">
                </checkSubject>
                <shortAnswerSubject v-if="questionBody.questionType === 3" :subjectId="subjectId"
                                    :questionBody="questionBody"
                                    :haveAnswer="true" :isDis="true">
                </shortAnswerSubject>
                <programmingSubject v-if="questionBody.questionType === 4" :subjectId="subjectId"
                                    :questionBody="questionBody" :isDis="true" :haveAnswer="true"
                                    @openAmendDialog="openAmendDialog"
                                    @openAnalysisDialog="openAnalysisDialog">
                </programmingSubject>
                <programmingSubjectMore v-if="questionBody.questionType === 5" :subjectId="subjectId"
                                        :questionBody="questionBody" :isDis="true" :haveAnswer="true"
                                        @openAmendDialog="openAmendDialog"
                                        @openAnalysisDialog="openAnalysisDialog">
                </programmingSubjectMore>
            </div>
        </div>

        <amendDialog :amendDialogShow="amendDialogShow"
                     :questionId="this.questionReadVM.id"
                     @closeAmendDialog="closeAmendDialog"
        ></amendDialog>

        <analysisDialog :analysisDialogShow="analysisDialogShow" :questionId="this.questionReadVM.id"
                        @closeAnalysisDialog="closeAnalysisDialog"></analysisDialog>
    </div>
</template>

<script>
    import radioSubject from "@/components/radioSubject.vue"
    import checkSubject from "@/components/checkSubject.vue"
    import shortAnswerSubject from "@/components/shortAnswerSubject.vue"
    import programmingSubject from "@/components/programmingSubject.vue"
    import programmingSubjectMore from "@/components/programmingSubjectMore.vue"
    import amendDialog from "@/components/amendDialog.vue"
    import analysisDialog from "@/components/analysisDialog.vue"
    import {
        checkCountByAnswerPaperAndDay,
        deleteWrongBookQuestion,
        wrongBookDetails
    } from "@/api/index.js"

    export default {
        filters: {
            formatQuestionType(type) {
                switch (type) {
                    case 0:
                        return "单选题";
                    case 1:
                        return "判断题";
                    case 2:
                        return "多选题";
                    case 3:
                        return "简答题";
                    case 4:
                        return "编程题";
                    case 5:
                        return "填空题";
                    default:
                        break;
                }
            }
        },
        props: {
            worngBookDetails: {
                type: Object,
                default: () => ({})
            },
            subjectId: {
                type: Number,
                default: 1
            }
        },
        components: {
            radioSubject,
            checkSubject,
            shortAnswerSubject,
            programmingSubject,
            programmingSubjectMore,
            analysisDialog,
            amendDialog
        },
        mounted() {
            let param = {
                id: this.worngBookDetails.id
            }
            wrongBookDetails(param).then(res => {
                if (res.code === "0000") {
                    this.questionReadVM = res.data.questionReadVM
                    this.answerRequest = res.data.answerRequest
                    this.questionBody = res.data.questionReadVM
                    this.questionBody.answerInfo = res.data.answerRequest
                }
            }).catch(() => {
                this.$router.push({
                    path: '/'
                })
            });
        },

        data() {
            return {
                value1: 4.5,
                questionReadVM: {},
                answerRequest: {},
                questionBody: {},
                amendDialogShow: false,
                analysisDialogShow: false
            }
        },
        methods: {

            openAmendDialog() {
                this.amendDialogShow = true;
            },
            closeAmendDialog() {
                this.amendDialogShow = false;
            },
            openAnalysisDialog() {
                this.analysisDialogShow = true;
            },
            closeAnalysisDialog() {
                this.analysisDialogShow = false;
            },
            collectQuestion() {
                this.$message({
                    type: 'success',
                    message: '收藏成功！'
                });
            }


            // deleteWrongRecord(id) {
            //     this.$confirm('此操作将移除该题, 是否继续?', '提示', {
            //         confirmButtonText: '确定',
            //         cancelButtonText: '取消',
            //         type: 'warning'
            //     }).then(() => {
            //         deleteWrongBookQuestion(id).then(res => {
            //             if (res.code === "0000") {
            //                 this.$emit('delete-form-list', id);
            //             } else {
            //                 this.$message({
            //                     message: res.message,
            //                     type: 'warning'
            //                 });
            //             }
            //         })
            //         this.$message({
            //             type: 'success',
            //             message: '删除成功!'
            //         });
            //     }).catch(() => {
            //         this.$message({
            //             type: 'info',
            //             message: '已取消删除'
            //         });
            //     });
            //
            // },
        }
    }
</script>

<style lang="scss" scoped>
/* 错题卡片容器 */
.wrong-book-card {
    width: 1200px;
    margin-top: 16px;
    position: relative;
}

/* 卡片容器 */
.card-container {
    background: #ffffff;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
    border: 1px solid #ebeef5;

    &:hover {
        box-shadow: 0 6px 20px rgba(64, 158, 255, 0.15);
        transform: translateY(-2px);
    }
}

/* 卡片头部 */
.card-header {
    background: linear-gradient(135deg, #409EFF 0%, #66B1FF 100%);
    padding: 6px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .header-left {
        display: flex;
        align-items: center;
        gap: 12px;
        color: #ffffff;
        font-size: 14px;

        .question-type-tag {
            display: flex;
            align-items: center;
            gap: 6px;
            background: rgba(255, 255, 255, 0.2);
            padding: 4px 12px;
            border-radius: 20px;
            font-weight: 500;

            i {
                font-size: 14px;
            }
        }

        .divider {
            opacity: 0.5;
        }

        .answer-time {
            display: flex;
            align-items: center;
            gap: 6px;
            opacity: 0.9;

            i {
                font-size: 14px;
            }
        }
    }

    .header-right {
        .wrong-badge {
            display: flex;
            align-items: center;
            gap: 4px;
            background: rgba(245, 108, 108, 0.9);
            color: #ffffff;
            padding: 4px 12px;
            border-radius: 20px;
            font-size: 12px;
            font-weight: 500;

            i {
                font-size: 12px;
            }
        }
    }
}

/* 卡片内容 */
.card-content {
    padding: 0;
    background: #ffffff;

    /* 子组件样式覆盖 */
    ::v-deep .subject-container {
        border-radius: 0;
        box-shadow: none;
        border: none;
    }

    ::v-deep .el-card {
        border-radius: 0;
        box-shadow: none;
        border: none;
        border-top: 1px solid #f0f0f0;
    }
}

/* 操作按钮区域（如果需要启用） */
.card-actions {
    padding: 12px 20px;
    border-top: 1px solid #f0f0f0;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    background: #fafafa;

    .action-btn {
        display: flex;
        align-items: center;
        gap: 4px;
        padding: 6px 16px;
        border-radius: 20px;
        font-size: 13px;
        cursor: pointer;
        transition: all 0.2s ease;
        border: 1px solid transparent;

        &.analysis-btn {
            color: #409EFF;
            background: #ecf5ff;
            border-color: #b3d8ff;

            &:hover {
                background: #409EFF;
                color: #ffffff;
            }
        }

        &.correct-btn {
            color: #E6A23C;
            background: #fdf6ec;
            border-color: #f5dab1;

            &:hover {
                background: #E6A23C;
                color: #ffffff;
            }
        }

        &.collect-btn {
            color: #F56C6C;
            background: #fef0f0;
            border-color: #fbc4c4;

            &:hover {
                background: #F56C6C;
                color: #ffffff;
            }
        }

        i {
            font-size: 14px;
        }
    }
}
</style>
